import {
  ActionButton,
  Card,
  useGlobalNavigationHotkeys,
  useHotkeys,
} from "@permutation-city/ui";
import {
  Outlet,
  createRootRoute,
  useLocation,
  useNavigate,
} from "@tanstack/react-router";
import { IncentivesFormNavButton } from "../components/IncentivesFormNavButton";
import { UserBalance } from "../components/UserBalance";
import { useIncentivesQuery } from "../queries/useIncentivesQuery";

export const Route = createRootRoute({
  component: Root,
  notFoundComponent: () => {
    return (
      <p className="text-2xl font-bold text-center mt-24">404 NOT FOUND</p>
    );
  },
});

function Root() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: incentives } = useIncentivesQuery();

  useGlobalNavigationHotkeys();
  useHotkeys("ctrl + B", () => {
    navigate({ to: "/" });
  });

  const showBackButton =
    (location.pathname !== "/" &&
      incentives?.length &&
      incentives.length > 1) ||
    location.pathname === "/create";

  return (
    <div className="grid grid-rows-[40px_auto] h-full min-w-0 min-h-0">
      <div className="flex items-center justify-between px-4">
        {showBackButton && (
          <ActionButton hotkey="^B" onClick={() => navigate({ to: "/" })}>
            Go back
          </ActionButton>
        )}

        <div>
          <IncentivesFormNavButton />
        </div>
        <UserBalance />
      </div>

      <div className="h-full px-4 pb-4">
        <Card>
          <Outlet />
        </Card>
      </div>
    </div>
  );
}
